/* Apex guidemallar 2026-10. Valfri förbättring: markerar aktuellt avsnitt i innehållsförteckningen och visar
   en fast "Innehåll"-knapp på mobil när man har scrollat förbi rutan. Sidan fungerar helt utan skriptet. */
(function () {
  var body = document.querySelector('[data-ag-body]');
  if (!body) return;
  var mobile = window.matchMedia('(max-width: 1279px)');
  var fab = document.querySelector('[data-ag-fab]');
  var inline = document.querySelector('[data-ag-toc-inline]');
  var links = document.querySelectorAll('[data-ag-toc] a[href^="#"]');

  links.forEach(function (a) {
    a.addEventListener('click', function () {
      if (fab) fab.removeAttribute('open');
      if (inline && mobile.matches) inline.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && fab && fab.hasAttribute('open')) fab.removeAttribute('open');
  });

  if (!('IntersectionObserver' in window)) return;

  if (fab && inline) {
    var inlineAbove = false, bodyVisible = false;
    var sync = function () {
      var show = mobile.matches && inlineAbove && bodyVisible;
      if (show) { fab.removeAttribute('hidden'); } else { fab.setAttribute('hidden', ''); fab.removeAttribute('open'); }
    };
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { inlineAbove = !e.isIntersecting && e.boundingClientRect.top < 0; });
      sync();
    }).observe(inline);
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bodyVisible = e.isIntersecting; });
      sync();
    }, { rootMargin: '0px 0px -40% 0px' }).observe(body);
    if (mobile.addEventListener) mobile.addEventListener('change', sync);
  }

  var map = {};
  links.forEach(function (a) {
    var id = decodeURIComponent(a.getAttribute('href').slice(1));
    (map[id] = map[id] || []).push(a);
  });
  var headings = Array.prototype.filter.call(body.querySelectorAll('h2[id]'), function (h) { return map[h.id]; });
  if (!headings.length) return;
  var current = null;
  var setActive = function (id) {
    if (id === current) return;
    current = id;
    links.forEach(function (a) { a.classList.remove('is-active'); a.removeAttribute('aria-current'); });
    (map[id] || []).forEach(function (a) { a.classList.add('is-active'); a.setAttribute('aria-current', 'location'); });
  };
  var io = new IntersectionObserver(function () {
    var id = null;
    headings.forEach(function (h) { if (h.getBoundingClientRect().top < window.innerHeight * 0.3) id = h.id; });
    if (id) setActive(id);
  }, { rootMargin: '0px 0px -65% 0px', threshold: [0, 1] });
  headings.forEach(function (h) { io.observe(h); });
})();
